import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import withComponentName from '../../../decorators/withComponentName';
import ButtonComponent from '../../Buttons/ButtonComponent';

import Styles from './styles.module.scss';

import { fundamentalData, alternativeData } from '../../../data/homepage/dueDeligenceData';

const cx = classNames.bind(Styles);

export const CoverageSection = ({ itemsColorType }) => (
  <section className={cx('coverage-section', {
    'transparent-items': itemsColorType === 'transparent',
    'blue-items': itemsColorType === 'blue',
  })}
  >
    <div className={cx('data-section', 'fundamental-data')}>
      <h4>Fundamental Data and News</h4>
      <ul>
        {fundamentalData.map(({
          id,
          text,
          icon,
          description,
          hoverClass,
          comingSoon,
        }) => (
          <li
            className={cx('data-list-item', { 'coming-soon-data': comingSoon })}
            key={id}
          >
            <FontAwesomeIcon className={cx(hoverClass)} icon={icon} />
            <p>{text}</p>
            {comingSoon && (
              <span>coming soon</span>
            )}
            <p className={Styles['data-list-item-description']}>
              {description}
            </p>
          </li>
        ))}
      </ul>
    </div>
    <div className={cx('data-section', 'alternative-data')}>
      <h4>Alternative Data</h4>
      <ul>
        {alternativeData.map(({
          id,
          text,
          icon,
          comingSoon,
          comingSoonMore,
          description,
          hoverClass,
          starIcon,
        }) => (
          <li
            className={
              cx('data-list-item',
                {
                  'coming-soon-data': comingSoon,
                  'coming-soon-more': comingSoonMore,
                })
            }
            key={id}
          >
            {starIcon ? (
              <i className={cx('star-icon', hoverClass)} />
            ) : (
              <FontAwesomeIcon className={cx(hoverClass)} icon={icon} />
            )}
            <p>{text}</p>
            {comingSoon && (
              <span>coming soon</span>
            )}
            <p className={Styles['data-list-item-description']}>
              {description}
            </p>
          </li>
        ))}
      </ul>
    </div>
    <ButtonComponent
      value="Build A Watchlist"
      longer
      path="/watchlists"
    />
  </section>
);

export default withComponentName(CoverageSection);
